import { useEffect, useState } from "react";

/**
 * Debounce hodnoty pro fulltext vyhledávání v tabulkách — query se posílá až
 * po pauze v psaní, ať se neodpaluje request na každý znak. Jednotný vzor pro
 * všechny list-y (viz klienti/faktury filter bary).
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
